import { arrayOf, shape, string } from 'prop-types';
import React from 'react';
import { GoArrowRight } from 'react-icons/go';

function ShadeCard({ shades, startLabel, endLabel }) {
  return (
    <div className="shade-card">
      <div className="d-flex justify-content-between align-items-center small">
        <span>{startLabel}</span>
        <GoArrowRight className="mx-4" />
        <span>{endLabel}</span>
      </div>
      <div className="d-flex">
        {shades.map(({ color, title }) => (
          <div
            key={color}
            className="shade-card__shade flex-grow-1"
            title={title}
            style={{ backgroundColor: color, height: '20px' }}
          />
        ))}
      </div>
    </div>
  );
}

ShadeCard.propTypes = {
  shades: arrayOf(shape({ color: string, title: string }).isRequired)
    .isRequired,
  startLabel: string,
  endLabel: string,
};

ShadeCard.defaultProps = {
  startLabel: '',
  endLabel: '',
};

export default ShadeCard;
